<template>
	<div class="toggle" @click="toggleIfEnabled" :class="{ active: active, disabled: disabled }">
		<span class="slider"></span>
	</div>
</template>

<script lang="ts">
export default {
	name: 'TheToggle',
	data() {
		return {};
	},
	props: {
		active: {
			type: Boolean,
			required: true,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	emits: ['toggle'],
	methods: {
		toggleIfEnabled() {
			if (!this.disabled) {
				this.$emit('toggle');
			}
		},
	},
};
</script>

<style lang="scss">
@use '../scss/vars.scss' as *;

.toggle {
	display: flex;
	position: relative;
	align-self: flex-end;
	width: 48px;
	min-width: 48px;
	height: 25px;

	.slider {
		position: absolute;
		cursor: pointer;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: var(--el-color-lightgrey-2);
		transition: 0.4s;
		border-radius: 12px;

		&:before {
			position: absolute;
			content: '';
			height: 19px;
			width: 19px;
			left: 2px;
			bottom: 3px;
			background-color: #fff;
			transition: 0.4s;
			border-radius: 50%;
		}
	}
	&.active {
		.slider {
			background-color: var(--el-color-green);
			box-shadow: 0 0 1px var(--el-color-green);

			&:before {
				-webkit-transform: translateX(24px);
				-ms-transform: translateX(24px);
				transform: translateX(24px);
			}
		}
	}
	&.disabled {
		opacity: 0.5;
		cursor: not-allowed;

		.slider {
			cursor: not-allowed;
		}
	}
}
</style>
